import React from 'react';
import './BrokersSection.css';

interface BrokerInfo {
  name: string;
  logo: string;
  country: string;
  products: string[];
  integrated: boolean;
}

const BrokersSection: React.FC = () => {
  const brokers: BrokerInfo[] = [
    {
      name: 'Webull',
      logo: '/images/webull.png',
      country: 'US',
      products: ['Stocks', 'ETFs'],
      integrated: false
    },
    {
      name: 'Wealthsimple',
      logo: '/images/wealthsimple.png',
      country: 'Canada',
      products: ['Stocks', 'ETFs'],
      integrated: false
    },
    {
      name: 'Tradier',
      logo: '/images/tradier.png',
      country: 'US',
      products: ['Stocks', 'ETFs'],
      integrated: true
    },
    {
      name: 'TradeStation',
      logo: '/images/tradestation.png',
      country: 'US',
      products: ['Stocks', 'ETFs', 'Futures'],
      integrated: true
    },
    {
      name: 'Stake',
      logo: '/images/stake.png',
      country: 'Australia',
      products: ['Stocks', 'ETFs'],
      integrated: false
    },
    {
      name: 'Schwab',
      logo: '/images/schwab.png',
      country: 'US',
      products: ['Stocks', 'ETFs'],
      integrated: false
    },
    {
      name: 'Questrade',
      logo: '/images/questrade.png',
      country: 'Canada',
      products: ['Stocks', 'ETFs'],
      integrated: false
    },
    {
      name: 'E-Trade',
      logo: '/images/etrade.png',
      country: 'US',
      products: ['Stocks', 'ETFs'],
      integrated: false
    },
    {
      name: 'Alpaca',
      logo: '/images/alpaca.png',
      country: 'US',
      products: ['Stocks', 'ETFs'],
      integrated: false
    },
    {
      name: 'Kraken',
      logo: '/images/kraken.png',
      country: 'International',
      products: ['Crypto'],
      integrated: false
    },
    {
      name: 'Coinbase',
      logo: '/images/coinbase.png',
      country: 'International',
      products: ['Crypto'],
      integrated: false
    },
    {
      name: 'IBKR',
      logo: '/images/ibkr.png',
      country: 'US',
      products: ['Stocks', 'ETFs', 'Futures'],
      integrated: false
    },
    {
      name: 'TastyTrade',
      logo: '/images/tastytrade.png',
      country: 'US',
      products: ['Stocks', 'ETFs', 'Futures'],
      integrated: false
    }
  ];

  return (
    <section className="brokers-section">
      <div className="container">
        <div className="brokers-title">
          <h2>Integrated with Leading Brokers</h2>
          <p>Seamlessly connect to these trusted trading platforms</p>
        </div>
        
        <div className="brokers-scroller-container">
          <div className="brokers-scroller">
            {/* Create a pattern that shows integrated brokers more frequently */}
            {(() => {
              const integratedBrokers = brokers.filter(broker => broker.integrated);
              const soonBrokers = brokers.filter(broker => !broker.integrated);
              
              // Create a pattern where every 2 integrated brokers are followed by 2 soon brokers
              const patternArray = [];
              const cycles = Math.ceil(brokers.length / 2); // How many cycles to create
              
              for (let i = 0; i < cycles; i++) {
                // Add integrated brokers
                patternArray.push(...integratedBrokers);
                
                // Add next 2 soon brokers (with wraparound)
                const startIdx = (i * 2) % soonBrokers.length;
                patternArray.push(soonBrokers[startIdx]);
                patternArray.push(soonBrokers[(startIdx + 1) % soonBrokers.length]);
              }
              
              // Duplicate the pattern for a better infinite scroll effect
              const duplicatedPattern = [...patternArray, ...patternArray];
              
              // Return the mapped pattern
              return duplicatedPattern.map((broker, index) => (
                <div 
                  className={`broker-item ${broker.integrated ? 'integrated' : ''}`} 
                  key={`${broker.name}-${index}`}
                >
                  <div className="broker-logo">
                    <img src={broker.logo} alt={`${broker.name} logo`} />
                    {broker.integrated && <span className="integrated-badge">Integrated</span>}
                    {!broker.integrated && <span className="soon-badge">Soon</span>}
                  </div>
                  <div className="broker-info">
                    <div className="broker-name">
                      <span className={`legend-dot ${broker.country.toLowerCase()}`}></span>
                      {broker.name}
                    </div>
                    <div className="broker-country">{broker.country}</div>
                    <div className="broker-products">{broker.products.join(', ')}</div>
                  </div>
                </div>
              ));
            })()}
          </div>
        </div>
        
        <div className="brokers-legend">
          <div className="legend-item">
            <span className="legend-dot us"></span>
            <span className="legend-text">United States</span>
          </div>
          <div className="legend-item">
            <span className="legend-dot canada"></span>
            <span className="legend-text">Canada</span>
          </div>
          <div className="legend-item">
            <span className="legend-dot australia"></span>
            <span className="legend-text">Australia</span>
          </div>
          <div className="legend-item">
            <span className="legend-dot international"></span>
            <span className="legend-text">International</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrokersSection; 